import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logolatest from '../assets/images/logos/logolatest.jpg';

const HomeNavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isServiceProvidersOpen, setIsServiceProvidersOpen] = useState(false);
  const navigate = useNavigate();
  const { access_token, logout } = useAuth();

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 991.98);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsServiceProvidersOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/Login');
  };

  // Dynamic styles based on screen size
  const getCollapseStyles = () => {
    const baseStyles = {
      transition: 'all 0.3s ease-in-out'
    };

    if (isMobile) {
      return {
        ...baseStyles,
        backgroundColor: 'white',
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        zIndex: 1000,
        boxShadow: isMenuOpen ? '0 2px 10px rgba(0,0,0,0.1)' : 'none',
        borderRadius: '0 0 8px 8px',
        padding: isMenuOpen ? '0.5rem 0' : '0'
      };
    }

    return baseStyles;
  };

  const getNavLinkStyles = () => {
    const baseStyles = {
      color: 'black',
      fontSize: '1.2rem',
      padding: '0.8rem 1rem',
      display: 'block',
      textDecoration: 'none',
      lineHeight: '1.5',
      fontFamily: 'inherit',
      fontWeight: 700
    };

    if (isMobile) {
      return {
        ...baseStyles,
        backgroundColor: 'white'
      };
    }

    return baseStyles;
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white" style={{
      padding: '1rem 0',
      minHeight: '80px',
      position: isMobile ? 'relative' : 'static'
    }}>
      <div className="container" style={{ position: isMobile ? 'relative' : 'static' }}>
        <Link className="navbar-brand" to="/" onClick={closeMenu}>
          <img 
            src={logolatest}
            alt="Studorez Logo" 
            style={{ height: '50px', width: 'auto' }}
          />
        </Link>
        
        {/* Mobile Menu Toggle Button */}
        <button 
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="navbarNav" 
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
          style={{
            border: 'none',
            outline: 'none',
            background: 'transparent'
          }}
        >
          <span style={{
            display: 'block',
            width: '25px',
            height: '3px',
            backgroundColor: '#333',
            margin: '3px 0',
            transition: '0.3s',
            transform: isMenuOpen ? 'rotate(-45deg) translate(-5px, 6px)' : 'none'
          }}></span>
          <span style={{
            display: 'block',
            width: '25px',
            height: '3px',
            backgroundColor: '#333',
            margin: '3px 0',
            transition: '0.3s',
            opacity: isMenuOpen ? '0' : '1'
          }}></span>
          <span style={{
            display: 'block',
            width: '25px',
            height: '3px',
            backgroundColor: '#333',
            margin: '3px 0',
            transition: '0.3s',
            transform: isMenuOpen ? 'rotate(45deg) translate(-5px, -6px)' : 'none'
          }}></span>
        </button>

        {/* Navigation Menu */}
        <div 
          className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} 
          id="navbarNav"
          style={getCollapseStyles()}
        >
          <ul className="navbar-nav ms-auto" style={{ backgroundColor: isMobile ? 'white' : 'transparent' }}>
            <li className="nav-item">
              <Link 
                className="nav-link" 
                to="/" 
                onClick={closeMenu}
                style={getNavLinkStyles()}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                onMouseLeave={(e) => e.target.style.backgroundColor = isMobile ? 'white' : 'transparent'}
              >
                Home
              </Link>
            </li>

            {/* Show Login and Register links only for non-authenticated users */}
            {!access_token && (
              <>
                <li className="nav-item">
                  <Link 
                    className="nav-link" 
                    to="/Login" 
                    onClick={closeMenu}
                    style={getNavLinkStyles()}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = isMobile ? 'white' : 'transparent'}
                  >
                    Login
                  </Link>
                </li>

                <li className="nav-item dropdown" 
                    onMouseEnter={() => !isMobile && setIsServiceProvidersOpen(true)}
                    onMouseLeave={() => !isMobile && setIsServiceProvidersOpen(false)}
                    style={{ position: 'relative' }}
                >
                  <span 
                    className="nav-link" 
                    onClick={() => isMobile && setIsServiceProvidersOpen(!isServiceProvidersOpen)}
                    style={{
                      ...getNavLinkStyles(),
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = isMobile ? 'white' : 'transparent'}
                  >
                    Service providers <span style={{ fontSize: '0.7rem', marginLeft: '3px', verticalAlign: 'middle' }}>{isServiceProvidersOpen ? '▲' : '▼'}</span>
                  </span>
                  <ul 
                    className={`dropdown-menu ${isServiceProvidersOpen ? 'show' : ''}`}
                    style={{
                      position: isMobile ? 'static' : 'absolute',
                      backgroundColor: 'white',
                      border: isMobile ? 'none' : '1px solid #dee2e6',
                      borderRadius: isMobile ? '0' : '0.375rem',
                      padding: isMobile ? '0 0 0 1rem' : '0.5rem 0',
                      margin: isMobile ? '0' : '0',
                      boxShadow: isMobile ? 'none' : '0 0.5rem 1rem rgba(0,0,0,0.15)',
                      minWidth: isMobile ? 'auto' : '200px',
                      display: isServiceProvidersOpen ? 'block' : 'none'
                    }}
                  >
                    <li>
                      <Link 
                        className="dropdown-item" 
                        to="/ProviderRegister"
                        onClick={closeMenu}
                        style={{
                          color: 'black',
                          padding: '0.5rem 1rem',
                          display: 'block',
                          textDecoration: 'none',
                          fontSize: isMobile ? '1.1rem' : '1rem'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                      >
                        Accommodation Providers
                      </Link>
                    </li>
                    <li>
                      <Link 
                        className="dropdown-item" 
                        to="/TutorRegister"
                        onClick={closeMenu}
                        style={{
                          color: 'black',
                          padding: '0.5rem 1rem',
                          display: 'block',
                          textDecoration: 'none',
                          fontSize: isMobile ? '1.1rem' : '1rem'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                      >
                        Tutors
                      </Link>
                    </li>
                  </ul>
                </li>
              </>
            )}

            {/* Show logout link for any authenticated user */}
            {access_token && (
              <li className="nav-item">
                <Link 
                  className="nav-link"
                  to="/Login"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                    closeMenu();
                  }}
                  style={getNavLinkStyles()}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = isMobile ? 'white' : 'transparent'}
                >
                  Logout
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default HomeNavBar;